import { Banner } from '../../../../types/banner';
import { BannerMetadataLine } from '../../../../types/library-metadata';

export const getBannerMetadata = (banner: Banner): BannerMetadataLine[] => {
  const { title, suggested_copy, viral_score } = banner;
  const lines: BannerMetadataLine[] = [];

  // Primera línea: título
  lines.push({
    text: title || 'Asset',
    fontWeight: 'bold',
    fontSize: 'lg'
  });

  // Segunda línea: suggested_copy (ahora a nivel banner)
  if (suggested_copy) {
    lines.push({
      text: suggested_copy
    });
  }

  // Tercera línea: viral_score (ahora a nivel banner)
  if (typeof viral_score === 'number') {
    let color = 'rgba(255,255,255,0.9)';

    if (viral_score > 80) {
      color = '#52c41a';
    } else if (viral_score > 50) {
      color = '#faad14';
    }

    lines.push({
      text: `Viral score ${viral_score}`,
      color,
      fontWeight: 'bold'
    });
  }

  return lines;
};
